import React from "react";
import { string } from "prop-types";

import * as S from "./styled";

const ConfirmationMessage = ({ agentName }) => (
  <S.ConfirmationContainer>
    <S.Icon />
    <S.Title>Message Sent</S.Title>
    <S.Text>You’ll hear from {agentName} shortly.</S.Text>
  </S.ConfirmationContainer>
);

ConfirmationMessage.propTypes = {
  agentName: string.isRequired
};

export default ConfirmationMessage;
